<button mat-icon-button (click)="openUserCall()" tabindex="-1">
  @if (isMobile()) {
    <span class="material-symbols-outlined"> smartphone </span>
  }
  @if (!isMobile()) {
    <span class="material-symbols-outlined"> call </span>
  }
</button>
